import script from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=1d0820ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d0820ec"]])

export default __exports__